import { FC } from "react";
import styles from "./sample-subheader.module.scss";

const SampleSubheaderDivider: FC = () => (
  <div className={styles.subheader_divider} />
);

export default SampleSubheaderDivider;
